<template>
    <app-layout>
        <create-view
            :model="model"
        />
    </app-layout>
</template>

<script>
import AppLayout from "../../layouts/AppLayout.vue";
import CreateView from "../../components/views/create/Index.vue";
import {mapGetters} from "vuex";

export default {
    name: "GiftCardsCreate",

    components: {
        CreateView,
        AppLayout
    },

    computed: {
        ...mapGetters({
            model: 'gift-cards/getModel',
        })
    },
}
</script>

<style lang="sass">

</style>